import { render, staticRenderFns } from "./CarrierWithImage.vue?vue&type=template&id=62f0d37c&"
import script from "./CarrierWithImage.vue?vue&type=script&lang=js&"
export * from "./CarrierWithImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports